import React, { useEffect, useState } from 'react';
import { academicProgramsService } from '../../../../services';

const ProgramCard = ({ programName, programId, cipCode, cipTitle, degreeLevel, deliveryMode, creditMin, creditMax, programStatus }) => (
    <div className="border rounded p-3 bg-light">
        <div>
            <strong>{programName || <span className="text-muted">—</span>}</strong>
            {programId ? <span className="text-muted ml-2">(ID: {programId})</span> : null}
        </div>
        <div className="text-muted small mt-1">
            {cipCode ? <span className="mr-3">CIP: {cipCode}{cipTitle ? ` — ${cipTitle}` : ''}</span> : null}
            {degreeLevel ? <span className="mr-3">Level: {degreeLevel}</span> : null}
            {programStatus ? <span>Status: {programStatus}</span> : null}
        </div>
        <div className="text-muted small">
            {deliveryMode ? <span className="mr-3">Delivery: {deliveryMode}</span> : null}
            {(creditMin || creditMax)
                ? <span>Credits: {creditMin ?? '—'}–{creditMax ?? '—'}</span>
                : null}
        </div>
    </div>
);

export const SplitRequestView = ({ requestDetails }) => {
    const [splitPrograms, setSplitPrograms] = useState(null);

    useEffect(() => {
        if (!requestDetails.requestID) return;
        setSplitPrograms(null);
        const res = academicProgramsService.getSplitProgramRequests(requestDetails.requestID);
        Promise.resolve(res).then(data => setSplitPrograms(data ?? []));
    }, [requestDetails.requestID]);

    return (
        <div className="request-type-details">
            <h5 className="mb-1">Split Request Details</h5>
            <hr className="mt-2 mb-3" />

            <div className="text-muted small font-weight-bold mb-2">ORIGINAL PROGRAM</div>
            <ProgramCard
                programName={requestDetails.programName}
                programId={requestDetails.programID}
                cipCode={requestDetails.cipCode}
                cipTitle={requestDetails.cipTitle}
                degreeLevel={requestDetails.degreeLevel}
                deliveryMode={requestDetails.deliveryMode}
                creditMin={requestDetails.creditRequirementMinimum}
                creditMax={requestDetails.creditRequirementMaximum}
                programStatus={requestDetails.programStatus}
            />

            <div className="text-center my-3 text-muted">↓ splits into</div>

            {splitPrograms === null ? (
                <p className="text-muted font-italic small">Loading new programs…</p>
            ) : splitPrograms.length === 0 ? (
                <p className="text-muted font-italic small">No split program records found.</p>
            ) : (
                <>
                    <div className="text-muted small font-weight-bold mb-2">
                        NEW PROGRAMS FROM SPLIT ({splitPrograms.length})
                    </div>
                    {splitPrograms.map((prog, i) => (
                        <div key={prog.requestID ?? i} className={i > 0 ? 'mt-3' : ''}>
                            <div className="text-muted small mb-1">
                                Program {i + 1} of {splitPrograms.length}
                            </div>
                            <ProgramCard
                                programName={prog.programName}
                                cipCode={prog.cipCode}
                                cipTitle={prog.cipTitle}
                                degreeLevel={prog.degreeLevel}
                                deliveryMode={prog.deliveryMode}
                                creditMin={prog.creditRequirementMinimum}
                                creditMax={prog.creditRequirementMaximum}
                            />
                        </div>
                    ))}
                </>
            )}

            {requestDetails.additionalComments && (
                <div className="mt-3">
                    <div className="text-muted small font-weight-bold">Comments</div>
                    <div>{requestDetails.additionalComments}</div>
                </div>
            )}
        </div>
    );
};
